module.exports = __webpack_public_path__ + "img/silver.1c3dd7d0.png";